/**
 * Oath Contact Info Service
 * API calls for contact information
 */

import { OathStorageKeys } from '../models/userModels';
import { oathRefreshToken } from './oathAuthService';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const getAuthHeaders = () => {
  const token = localStorage.getItem(OathStorageKeys.JWT_TOKEN);
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
};

const authFetch = async (url, options = {}) => {
  const response = await fetch(url, {
    ...options,
    headers: {
      ...getAuthHeaders(),
      ...options.headers,
    },
  });

  if (response.status === 401) {
    const refreshResult = await oathRefreshToken();
    if (refreshResult.success) {
      return fetch(url, {
        ...options,
        headers: {
          ...getAuthHeaders(),
          ...options.headers,
        },
      });
    }
  }

  return response;
};

/**
 * Get all contact info categories
 */
export const getContactInfo = async () => {
  try {
    const response = await authFetch(`${BASE_URL}oath/contact-info`);

    if (!response.ok) {
      return { success: false, error: `Failed to fetch contact info: ${response.statusText}` };
    }

    const data = await response.json();
    const result = data.result !== undefined ? data.result : data;
    return { success: true, data: Array.isArray(result) ? result : [] };
  } catch (error) {
    return { success: false, error: error.message || 'Error fetching contact info' };
  }
};
